
import axios from "axios";

const CMS_BASE_URL      = "https://cms-stage.curebay.in/api/";

export function getLabInsightsData() {


  return axios.get(`${CMS_BASE_URL}labinsights-news?populate=first,second,second.secsub,third,third.thirdsub,fourth,fourth.fourthsub,fifth,fifth.fifthsub,sixth,sixth.sixthsub,seventh,seventh.sevensub,seventh.sevensub.points`, 
  );
 
 
}